<form (ngSubmit)="onSubmit()" [formGroup]="formGroup" #form="ngForm">
  <div class="row mt-2">
    <div class="col">
      <mat-form-field>
        <mat-label>{{ "forms.chartSettings.labels.type" | translate }}</mat-label>
        <mat-select formControlName="type" required>
          <mat-option *ngFor="let type of types" [value]="type">{{ "forms.chartSettings.types." + type | translate }}</mat-option>
        </mat-select>
        <mat-error>{{ getError("type") }}</mat-error>
      </mat-form-field>
    </div>
  </div>
  <!-- <div class="row mt-2">
    <div class="col">
      <mat-form-field>
        <mat-label>{{ "forms.chartSettings.labels.scale" | translate }}</mat-label>
        <mat-select formControlName="scales" required multiple>
          <mat-option *ngFor="let scale of scales" [value]="scale">{{ "forms.chartSettings.scales." + scale | translate }}</mat-option>
        </mat-select>
        <mat-error>{{ getError("scales") }}</mat-error>
      </mat-form-field>
    </div>
  </div> -->
  <div *ngIf="withSubmit" class="row justify-content-end mt-2">
    <div class="col-md-auto">
      <button mat-raised-button [appButtonLoading]="formLoading.loading" color="primary">
        {{ submitText | translate }}
      </button>
    </div>
  </div>
</form>
